module.exports = __webpack_public_path__ + "static/01-d564fcac4a9e8243c539310c4f782e29.jpg";